import { getFirestore, doc, collection, query, where, getDoc, onSnapshot, documentId } from "firebase/firestore"
import { useAppStore } from '@/stores/appdata'
import gameStateCommands from '@/commands/gameStateCommands'

const db = getFirestore()
const collectionName = 'profiles/'

function docToInstance(document) {
  const data = document.data()
  return data ? new Profile(
    document.id, data.email, data.firstname, data.lastname, data.avatar, data.color,
    data.role, data.dev, data.commercial, data.banned, data.activated, data.currentOrganisation, data.currentApps, data.organisations, data.appdata,
    data.created_at, data.activated_at, data.last_login_at, data.last_pwChange_at
  ) : null
}

export default class Profile {
  constructor(id, email, firstname, lastname, avatar, color, role, dev, commercial, banned, activated, currentOrganisation, currentApps, organisations, appdata, created_at, activated_at, last_login_at, last_pwChange_at) {
    this.id = id
    this.email = email
    this.firstname = firstname
    this.lastname = lastname
    this.avatar = avatar
    this.color = color
    this.role = role
    this.dev = dev
    this.commercial = commercial
    this.banned = banned
    this.activated = activated
    this.currentOrganisation = currentOrganisation
    this.currentApps = currentApps
    this.organisations = organisations
    this.appdata = appdata

    this.created_at = created_at
    this.activated_at = activated_at
    this.last_login_at = last_login_at
    this.last_pwChange_at = last_pwChange_at
  }

  static listenById(id, callback) {
    return onSnapshot(doc(db, collectionName, id), snapshot => {
      callback(docToInstance(snapshot))
    })
  }
  static listenAll(callback) {
    const appStore = useAppStore()
    const ids = appStore.app.users

    if (ids.length === 0) {
      callback([])
    } else {
      const docsQuery = query(collection(db, collectionName), where(documentId(), 'in', ids))
      onSnapshot(docsQuery, snapshot => {
        const list = []
        snapshot.forEach(document => {
          list.push(docToInstance(document))
        })
        callback(list)
      })
    }
  }
  static listenByRole(role, callback) {
    const appStore = useAppStore()
    const ids = appStore.app.users

    if (ids.length === 0) {
      callback([])
    } else {
      const docsQuery = query(collection(db, collectionName), where(documentId(), 'in', ids), where('role', '==', role))
      onSnapshot(docsQuery, snapshot => {
        const list = []
        snapshot.forEach(document => {
          list.push(docToInstance(document))
        })
        callback(list)
      })
    }
  }
  /**
   * Bascule vers l'application courante. Le droit d'accès est vérifié côté serveur :
   * un profil ne peut pas se rattacher à une application qui ne lui est pas ouverte.
   */
  async saveCurrentApp(applicationId) {
    const target = applicationId !== undefined
      ? applicationId
      : this.currentApps.app_myFirstBusiness
    await gameStateCommands.switchCurrentApplication(target)
  }

  /**
   * Profils d'une liste d'identifiants, par paquets de 30 (limite des requêtes « in »).
   * Le rappel reçoit la liste fusionnée ; renvoie le désabonnement.
   */
  static listenByIds(ids, callback) {
    const unique = [...new Set((ids || []).filter(Boolean))]
    if (unique.length === 0) {
      callback([])
      return () => {}
    }
    const chunks = []
    for (let index = 0; index < unique.length; index += 30) chunks.push(unique.slice(index, index + 30))
    const parts = chunks.map(() => null)
    const unsubscribers = chunks.map((chunk, index) => onSnapshot(
      query(collection(db, collectionName), where(documentId(), 'in', chunk)),
      snapshot => {
        const list = []
        snapshot.forEach(document => list.push(docToInstance(document)))
        parts[index] = list
        if (parts.every(part => part !== null)) callback(parts.flat())
      },
    ))
    return () => unsubscribers.forEach(unsubscribe => unsubscribe())
  }

  static async getById(id) {
    const document = await getDoc(doc(db, collectionName, id))
    return docToInstance(document)
  }
}
